// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._1bsb1lit{width:10pc}
._1bsb1wqb{width:60px}
._1bsb53f4{width:75pt}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/renderer/node_modules/@atlaskit/link-datasource/dist/esm/common/ui/common/render-svg.compiled.css"],"names":[],"mappings":"AAAA,WAAW,UAAU;AACrB,WAAW,UAAU;AACrB,WAAW,UAAU","sourcesContent":["._1bsb1lit{width:10pc}\n._1bsb1wqb{width:60px}\n._1bsb53f4{width:75pt}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
